import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:p-6" }
const _hoisted_6 = { class: "sm:flex sm:items-start" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "flex justify-between items-center mb-4" }
const _hoisted_9 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_10 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "bg-gray-50 rounded-lg p-4 mb-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "text-md font-semibold text-gray-900 mb-3" }, "ข้อมูลคูปอง", -1)
const _hoisted_14 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_15 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_16 = { class: "text-sm text-gray-900 ml-2" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_19 = { class: "text-sm text-gray-900 ml-2" }
const _hoisted_20 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_21 = { class: "text-sm text-gray-900 ml-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", { class: "text-md font-semibold text-gray-900 mb-3" }, "ประวัติการใช้งาน", -1)
const _hoisted_24 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_25 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_26 = { class: "bg-gray-50" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " ID ", -1)
const _hoisted_28 = { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Transaction ID ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " วันที่ใช้ ", -1)
const _hoisted_31 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_32 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_34 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_35 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_36 = {
  key: 1,
  class: "text-center py-8 bg-gray-50 rounded-lg"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "ยังไม่มีประวัติการใช้งานคูปองนี้", -1)
const _hoisted_38 = [
  _hoisted_37
]

import { ref, watch } from 'vue'
import dayjs from 'dayjs'
import { Coupon } from '@/views/coupon/type/coupon.type'

interface Props {
  show: boolean
  coupon: Coupon | null
}

interface Emits {
  (e: 'update:show', value: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewCouponDialog',
  props: {
    show: { type: Boolean },
    coupon: null
  },
  emits: ["update:show"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:show', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean
  coupon: Coupon | null
}

const XIcon = require("@heroicons/vue/solid/XIcon")




const selectedCoupon = ref<Coupon | null>(null)
const isLoading = ref(false)

const close = () => {
  emit('update:show', false)
}

const formatDate = (date: string | null) => {
  if (!date) return '-'
  return dayjs(date).locale('th').format('LLL')
}

// Watch for coupon changes
watch(() => props.coupon, (newCoupon) => {
  if (newCoupon) {
    selectedCoupon.value = newCoupon
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: close
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('messages.coupon.viewCoupon')) + " - " + _toDisplayString(selectedCoupon.value?.code), 1),
                  _createElementVNode("button", {
                    onClick: close,
                    class: "text-gray-400 hover:text-gray-600"
                  }, [
                    _createVNode(_unref(XIcon), { class: "h-6 w-6" })
                  ])
                ]),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "text-gray-500",
                        icon: ['fas', 'circle-notch'],
                        transform: "grow-6",
                        spin: ""
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('messages.coupon.code')) + ":", 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(selectedCoupon.value?.code), 1)
                          ]),
                          (selectedCoupon.value?.userId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('messages.coupon.userId')) + ":", 1),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(selectedCoupon.value.userId), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('messages.coupon.createdAt')) + ":", 1),
                            _createElementVNode("span", _hoisted_21, _toDisplayString(formatDate(selectedCoupon.value?.createdAt)), 1)
                          ])
                        ])
                      ]),
                      (selectedCoupon.value?.couponUsages && selectedCoupon.value.couponUsages.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("table", _hoisted_25, [
                                _createElementVNode("thead", _hoisted_26, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_27,
                                    _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('messages.coupon.userId')), 1),
                                    _hoisted_29,
                                    _hoisted_30
                                  ])
                                ]),
                                _createElementVNode("tbody", _hoisted_31, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCoupon.value.couponUsages, (usage) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: usage.id
                                    }, [
                                      _createElementVNode("td", _hoisted_32, _toDisplayString(usage.id), 1),
                                      _createElementVNode("td", _hoisted_33, _toDisplayString(usage.userId), 1),
                                      _createElementVNode("td", _hoisted_34, _toDisplayString(usage.transactionId), 1),
                                      _createElementVNode("td", _hoisted_35, _toDisplayString(formatDate(usage.createdAt)), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                    ]))
              ])
            ]),
            _createElementVNode("div", { class: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse" }, [
              _createElementVNode("button", {
                onClick: close,
                class: "w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
              }, " ปิด ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})